<template>
  <el-row :gutter="50" v-bind="$attrs" v-on="$listeners" class="CardContainer">
    <el-col
      :lg="24 / cols"
      v-for="(row, rowIndex) in data"
      :key="rowIndex"
      class="CardContainer-item"
    >
      <slot v-bind="{ row, rowIndex }" />
    </el-col>
  </el-row>
</template>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.CardContainer {
  margin-bottom: map-get($spacers, 4) * -1;

  &-item {
    @extend .mb-4;
  }
}
</style>

<script>
/**
 * Conteneur pour afficher des cartes
 */
export default {
  name: 'UbiCardContainer',
  props: {
    /**
     * Liste des éléments à afficher
     */
    data: Array,
    /**
     * Nombre de colonnes du conteneur
     */
    cols: { type: Number, default: 2 }
  }
}
</script>

<docs>
### Exemples

```javascript
let data = ...;

<ubi-container data={data}>
<template v-slot={row}>
  <ubi-card>...</ubi-card>
</template>
</ubi-container>
```
</docs>
